module.exports = __webpack_public_path__ + "img/portfolio-12.f8f1b37f.jpg";